export const searchFormOption = function () {
    return [
		{
		  prop: "keyword",
		  label: "关键字",
		  type: "input",
		  placeholder: "请输入车牌号/车架号",
		  width: "20%",
		},
        {
            prop: 'orgId',
            label: '出单机构',
            type: 'cascader',
            placeholder: '请选择出单机构',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.orgOption
        },
		{
		  prop: "saleNo",
		  label: "业务员",
		  type: "select",
		  width: "20%",
		  options: this.$store.state.app.salesmanList,
		},
		{
		    prop: 'date',
		    label: '到期时间',
			width: "25%",
			close: false,
		    type: 'range-date',
		}
    ]
}

export default {}